'use strict';

/**
 * Market Analysis - Market Product tab - Profile Graph Chart
 */
var MarketProductGroupProfileChartTransformerFactory = function MarketProductGroupProfileChartTransformerFactory($filter, DataTransformer) {
  function MarketProductGroupProfileChartTransformer(targetType, priority) {
    DataTransformer.call(this);
    this.sourceType = 'market-product-group-profile-chart';
    this.targetType = targetType;
    this.priority = priority || 0;
  }
  MarketProductGroupProfileChartTransformer.prototype = Object.create(DataTransformer.prototype);
  MarketProductGroupProfileChartTransformer.constructor = MarketProductGroupProfileChartTransformer;
  MarketProductGroupProfileChartTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  MarketProductGroupProfileChartTransformer.prototype.isCacheable = function () {
    return true;
  };
  MarketProductGroupProfileChartTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + metrics.join('-');
  };
  MarketProductGroupProfileChartTransformer.prototype.transform = function (data) {
    return data.domain.flattenedDomainCurves;
  };
  return MarketProductGroupProfileChartTransformer;
};
MarketProductGroupProfileChartTransformerFactory.$inject = ['$filter', 'DataTransformerFactory', 'CalculateEffectiveValueService', 'MomentService', 'MergeScenarioDataService'];
module.exports = MarketProductGroupProfileChartTransformerFactory;